import React from 'react';

export const BgIcon = () => (
  <svg viewBox='0 0 390 200' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g opacity='0.3' clipPath='url(#clip0_640_87214)'>
      <g opacity='0.25' filter='url(#filter0_f_640_87214)'>
        <ellipse
          cx='268.5'
          cy='106'
          rx='268.5'
          ry='106'
          transform='matrix(-1 0 0 1 446 -182)'
          fill='#3DAEFF'
        />
      </g>
      <g opacity='0.1' filter='url(#filter1_f_640_87214)'>
        <ellipse
          cx='166.5'
          cy='104.5'
          rx='166.5'
          ry='104.5'
          transform='matrix(-1 0 0 1 531 -111)'
          fill='#D3FFEE'
        />
      </g>
      <g opacity='0.4'>
        <mask id='mask0_640_87214' maskUnits='userSpaceOnUse' x='-5' y='0' width='401' height='138'>
          <rect
            x='-5'
            y='2.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 2.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='7.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 7.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='12.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 12.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='17.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 17.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='22.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 22.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='27.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 27.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='32.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 32.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='37.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 37.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='42.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 42.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='47.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 47.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='52.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 52.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='57.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 57.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='62.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 62.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='67.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 67.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='72.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 72.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='77.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 77.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='82.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 82.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='87.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 87.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='92.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 92.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='97.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 97.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='102.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 102.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='107.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 107.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='112.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 112.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='117.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 117.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='122.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 122.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='127.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 127.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='132.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 132.5)'
            fill='#21C1E2'
          />
          <rect
            x='-5'
            y='137.5'
            width='2'
            height='401'
            transform='rotate(-90 -5 137.5)'
            fill='#21C1E2'
          />
        </mask>
        <g mask='url(#mask0_640_87214)'>
          <g filter='url(#filter2_f_640_87214)'>
            <path
              d='M0 -45.5H391V123.5L195.5 45.8699L0 123.5V-45.5Z'
              fill='url(#paint0_linear_640_87214)'
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <filter
        id='filter0_f_640_87214'
        x='-171'
        y='-262'
        width='697'
        height='372'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='40' result='effect1_foregroundBlur_640_87214' />
      </filter>
      <filter
        id='filter1_f_640_87214'
        x='154'
        y='-155'
        width='421'
        height='297'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='22' result='effect1_foregroundBlur_640_87214' />
      </filter>
      <filter
        id='filter2_f_640_87214'
        x='-100'
        y='-145.5'
        width='591'
        height='369'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='50' result='effect1_foregroundBlur_640_87214' />
      </filter>
      <linearGradient
        id='paint0_linear_640_87214'
        x1='195.5'
        y1='8'
        x2='195.5'
        y2='82.5'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#439CEF' />
        <stop offset='1' stopColor='#439CEF' stopOpacity='0' />
      </linearGradient>
      <clipPath id='clip0_640_87214'>
        <rect width='390' height='200' fill='white' transform='matrix(-1 0 0 1 390 0)' />
      </clipPath>
    </defs>
  </svg>
);

export const BgIconDark = () => (
  <svg
    className='h-auto w-full'
    viewBox='0 0 390 255'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    preserveAspectRatio='xMidYMid meet'
  >
    <g opacity='0.3' clipPath='url(#clip0_1722_64583)'>
      <g opacity='0.18' filter='url(#filter0_f_1722_64583)'>
        <ellipse
          cx='195'
          cy='272.5'
          rx='195'
          ry='107.5'
          transform='rotate(-180 195 272.5)'
          fill='#3DAEFF'
        />
      </g>
    </g>
    <defs>
      <filter
        id='filter0_f_1722_64583'
        x='-80'
        y='85'
        width='550'
        height='375'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='40' result='effect1_foregroundBlur_1722_64583' />
      </filter>
      <clipPath id='clip0_1722_64583'>
        <rect width='390' height='255' fill='white' transform='translate(390 255) rotate(-180)' />
      </clipPath>
    </defs>
  </svg>
);
